import axiosInstance from "../../lib/axiosInstance"
// Action Types
export const USER_ID_LIST_REQUEST = "USER_ID_LIST_REQUEST"
export const USER_ID_LIST_SUCCESS = "USER_ID_LIST_SUCCESS"
export const USER_ID_LIST_FAILURE = "USER_ID_LIST_FAILURE"

// Action Creators
export const userIdListRequest = () => ({
  type: USER_ID_LIST_REQUEST,
})

export const userIdListSuccess = (data) => ({
  type: USER_ID_LIST_SUCCESS,
  payload: data,
})

export const userIdListFailure = (error) => ({
  type: USER_ID_LIST_FAILURE,
  payload: error,
})

// Thunk Function

export const getUserList = (userId) => {
  return async (dispatch) => {
    dispatch(userIdListRequest())

    try {
      const response = await axiosInstance.get(`/api/currentUser?user_id=${userId}`)
      dispatch(userIdListSuccess(response.data))
    } catch (error) {
      console.error("API Error:", error.message)
      dispatch(userIdListFailure(error.message))
    }
  }
}
